import React from 'react';
import FormSelect from 'shared/forms/FormSelect';

const CustomSearchEntityDropdown = (props) => {
  const data = [
    {
      description: 'Orders',
      value: 'orders'
    }
  ]

  return <FormSelect data={data} textField="description" dataItemKey="value" {...props} />;
};

export default CustomSearchEntityDropdown;
